let initialState = {
  data: {}
}

function dataList(state = initialState, action) {
  let newState = {
    ...state
  };
  switch (action.type) {
    case 'UPDATE_DATALIST':
      newState.data[action.key] = action.data;
      return newState;
    case 'DELETE_ITEM_DATALIST':
      let Data = newState.data[action.key];
      Data = Data.filter(item => item[action.idKey] != action.id);
      newState.data[action.key] = Data;
      return newState;
    default:
      return newState;
  }
}

export { dataList }



// WEBPACK FOOTER //
// ./src/reducers/dataList.js